import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import type { GetVipRequestsResponse } from '@/api/requests/get-vip-requests'

export const mockGetBookingVipRequests = http.get(
  '/api/booking/v1/availability/vip',
  () => {
    const data: GetVipRequestsResponse[] = Array.from({ length: 100 }).map(
      () => ({
        roomTypeId: faker.number.int({ min: 10000, max: 99999 }),
        roomTypeDs: faker.lorem.word(),
        roomTypeQty: faker.number.int({ min: 1, max: 2 }),
        hotelName: faker.company.name(),
        hotelCorporateName: faker.company.name(),
        hotelChainName: faker.company.name(),
        hotelChainCorporateName: faker.company.name(),
        startDate: faker.date.past().toISOString(),
        endDate: faker.date.future().toISOString(),
        agencyObservation: faker.lorem.paragraph(),
        status: faker.helpers.arrayElement(['WAIT', 'RELEASED', 'DENIED']),
        reviewedUserId: faker.number.int({ min: 10000, max: 99999 }),
        created: faker.date.past().toISOString(),
        createdByUserId: faker.number.int({ min: 10000, max: 99999 }),
        createdByUserName: faker.person.firstName(),
        updated: faker.date.past().toISOString(),
        responseByUserId: faker.number.int({ min: 10000, max: 99999 }),
        responseByUserName: faker.person.firstName(),
      }),
    )

    return HttpResponse.json({ data })
  },
)
